import { API_NAMES, initApi } from "@usas/ui-web/utils/HttpApiHelper";
import { BASIC_INITIAL_STATE } from "@usas/ui-web/utils/HttpHelper";

const getLscBoardMembersData = (orgUnitId, state, setState) => {
  if (orgUnitId) {
    const api = initApi(API_NAMES.COMMON, state, setState);

    const orgUnitIdForUrl = orgUnitId ? encodeURIComponent(orgUnitId) : 'NaN';

    const url = `/OrgUnit/${orgUnitIdForUrl}/LscBoardMembers`;

    return api.executeArray ? api.executeArray(url, 'GET') : null;
  }
};

const INITIAL_LSC_BOARD_MEMBER_STATE = {
  ...BASIC_INITIAL_STATE
};

const LscBoardMemberData = {
  INITIAL_LSC_BOARD_MEMBER_STATE,
  getLscBoardMembersData
};

export default LscBoardMemberData;